import uzinfocomConfig from './Uzinfocom/navigationConfig';
import uportalConfig from './uportal/navigationConfig';
import uzatomConfig from './UzAtom/navigationConfig';

const minimumConfig = [
  {
    id: 'apps',
    title: 'Applications',
    type: 'group',
    auth: null,
    icon: 'react-outline:home',
    translate: 'Basic',
    children: [
      {
        id: 'apps.home',
        title: 'HomePage',
        type: 'item',
        icon: 'react-outline:home',
        url: '/',
        translate: 'Main',
      },
    ],
  },
];

const companyName = process.env.REACT_APP_COMPANY_NAME || 'Uzinfocom';

const navigationConfig =
  {
    Uzinfocom: uzinfocomConfig,
    uportal: uportalConfig,
    UzAtom: uzatomConfig,
  }[companyName] || minimumConfig;

export default navigationConfig;
